import React from 'react';
import _ from 'lodash';
import { Stack, FormControl, Typography, Select, MenuItem, FormHelperText, InputLabel, OutlinedInput } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { DebounceInput } from 'react-debounce-input';
import { CssTextField } from '../others/CssTextField';
import { getDependsOnValue, handleShowOn } from '../../services/functions';
import { useFullScreen, useResponsive } from '../../services/hooks';
import { RequiredField } from '../others/RequiredField';

const Row = props => {
  const { numRow, index, field, formik, originFieldName, originalField, wr312ChildrenCountIsSet, wr03ChildrenCountIsSet, wr6PlusChildrenCountIsSet, wr05ChildrenCountIsSet } = props;
  const [value, setValue] = React.useState(originalField.multichar_types ? originalField.multichar_types[index] == 'date' ? null : '' : '');
  const onChange = val => {
    setValue(val);
    const fieldClone = _.cloneDeep(formik.values[originFieldName]);
    fieldClone[numRow][field] = val;
    formik.setFieldValue(originFieldName, fieldClone);
  };

  React.useEffect(() => {
    if (wr312ChildrenCountIsSet && originFieldName == 'wr_3_12_children_count') {
      setValue(formik.values[originFieldName][numRow][field]);
    }
  }, [wr312ChildrenCountIsSet]);

  React.useEffect(() => {
    if (wr03ChildrenCountIsSet && originFieldName == 'wr_0_3_children_count') {
      setValue(formik.values[originFieldName][numRow][field]);
    }
  }, [wr03ChildrenCountIsSet]);

  React.useEffect(() => {
    if (wr6PlusChildrenCountIsSet && originFieldName == 'wr_6_plus_children_count') {
      setValue(formik.values[originFieldName][numRow][field]);
    }
  }, [wr6PlusChildrenCountIsSet]);

  React.useEffect(() => {
    if (wr05ChildrenCountIsSet && originFieldName == 'wr_0_5_children_count') {
      setValue(formik.values[originFieldName][numRow][field]);
    }
  }, [wr05ChildrenCountIsSet]);

  return (
    <FormControl fullWidth >
      <Typography variant="subtitle1" >
        <b>{field} #{numRow + 1}</b>
      </Typography>
      <DebounceInput
        style={{ margin: 3 }}
        debounceTimeout={500}
        element={CssTextField}
        name={field}
        label={`${field.toLowerCase()} #${numRow + 1}`}
        value={value}
        onChange={e => onChange(e.target.value)}
        variant="outlined"

      />
    </FormControl>
  );
};

export const MultiCharWithChoiceField = props => {
  const { field, formik, getFieldCallback } = props;
  const isDesktop = useResponsive('up', 'lg');
  const mediaWidth = useFullScreen() ? '300px' : '100%';
  const [numRows, setNumRows] = React.useState('');
  const [open, setOpen] = React.useState(false);
  const [description, setDescription] = React.useState('');
  const [wr03ChildrenCountIsSet, setWr03ChildrenCountIsSet] = React.useState(false);
  const [wr312ChildrenCountIsSet, setWr312ChildrenCountIsSet] = React.useState(false);
  const [wr6PlusChildrenCountIsSet, setWr6PlusChildrenCountIsSet] = React.useState(false);
  const [wr05ChildrenCountIsSet, setWr05ChildrenCountIsSet] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    if (field.disabled) {
      return;
    }
    setOpen(true);
  };

  const getRowStyle = () => {
    if (isDesktop) {
      return {
        marginBottom: '10px',
        padding: '5px'
      };
    }

    return {
      border: '1px solid',
      borderColor: 'secondary.main',
      marginTop: '10px',
      marginBottom: '5px',
      padding: '10px',
      borderRadius: '8px',
      boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.1)'
    };

  };


  const handleChange = value => {
    if (value == '') {
      setNumRows('');
      formik.setFieldValue(field.name, []);
    } else if (value == 0) {
      setNumRows(0);
      formik.setFieldValue(field.name, []);
    } else {
      setNumRows(parseInt(value));
      formik.setFieldValue(field.name, Array.from({ length: value }, () => ({})));
    }
    if (['wr_3_12_children_count', 'wr_0_3_children_count', 'wr_6_plus_children_count', 'wr_0_5_children_count'].includes(field.name)) {
      formik.setFieldValue('accomodation', '');
    }
  };

  React.useEffect(() => {
    if (props.initialParamsData.wr_3_12_children_count && field.name == 'wr_3_12_children_count' && !wr312ChildrenCountIsSet) {
      setNumRows(props.initialParamsData.wr_3_12_children_count.length);
      formik.setFieldValue('wr_3_12_children_count', props.initialParamsData.wr_3_12_children_count);
      setWr312ChildrenCountIsSet(true);
    }
    if (props.initialParamsData.wr_0_3_children_count && field.name == 'wr_0_3_children_count' && !wr03ChildrenCountIsSet) {
      setNumRows(props.initialParamsData.wr_0_3_children_count.length);
      formik.setFieldValue('wr_0_3_children_count', props.initialParamsData.wr_0_3_children_count);
      setWr03ChildrenCountIsSet(true);
    }
    if (props.initialParamsData.wr_6_plus_children_count && field.name == 'wr_6_plus_children_count' && !wr6PlusChildrenCountIsSet) {
      setNumRows(props.initialParamsData.wr_6_plus_children_count.length);
      formik.setFieldValue('wr_6_plus_children_count', props.initialParamsData.wr_6_plus_children_count);
      setWr6PlusChildrenCountIsSet(true);
    }
    if (props.initialParamsData.wr_0_5_children_count && field.name == 'wr_0_5_children_count' && !wr05ChildrenCountIsSet) {
      setNumRows(props.initialParamsData.wr_0_5_children_count.length);
      formik.setFieldValue('wr_0_5_children_count', props.initialParamsData.wr_0_5_children_count);
      setWr03ChildrenCountIsSet(true);
    }
  }, [field.dynamicOptions]);

  return (
    <Stack direction="column"
      style={{ display: field.hide ? 'none' : handleShowOn(
        field.show_on, formik.values,
        getFieldCallback(!_.isNil(field.show_on) ? field.show_on.trim().split(' ')[0].split('-')[0] : []))
        ? ''
        : 'none' }}>

      <Typography variant="subtitle1" >
        <b>{field.label}</b>
        <RequiredField required={field.required} isEmpty={numRows === ''} formikError={formik.touched[field.name] && Boolean(formik.errors[field.name])} />
      </Typography>
      <FormControl
        style={{ marginBottom: 15, maxWidth: mediaWidth }}
        fullWidth
        variant="outlined"
        error={formik.touched[field.name] && Boolean(formik.errors[field.name])}>
        {field.depends_on && _.isEmpty(formik.values[getDependsOnValue(field.depends_on)]) && _.isEmpty(field.dynamicOptions)
          ? <Typography color="error">{field.additional_info}</Typography>
          : (
            <>
              <InputLabel htmlFor={field.name}>{_.isEmpty(formik.values[field.name]) ? field.label : null}</InputLabel>
              <Select
                input={<OutlinedInput id={field.name} label={_.isEmpty(formik.values[field.name]) ? field.label : null}/>}
                sx={{
                  '.MuiOutlinedInput-notchedOutline': {
                    borderColor: 'primary.light'
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'primary.main'
                  },
                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'primary.dark'
                  }
                }}
                labelId={field.name}
                value={numRows}
                onChange={(e, v) => handleChange(e.target.value, v)}
                open = {open}
                onOpen = {handleOpen}
                onClose = {handleClose}
                name={field.label}
                id="qwe"
                disabled={field.disabled}
                IconComponent={_props => {
                  const rotate = _props.className.toString().includes('iconOpen');

                  return (
                    <div>
                      { rotate
                        ? <div style={{ color: 'red', cursor: 'pointer', marginRight: 5, marginBottom: 5, fontSize: 20 }}>X</div>
                        : <div><KeyboardArrowDownIcon
                          style={{ cursor: 'pointer' }}
                          onClick = {handleOpen}
                        /></div> }
                    </div>
                  );
                }}

              >
                <MenuItem value="">&nbsp;</MenuItem>
                { !_.isNil(formik.values[field.name])
                  ? !_.isNil(field.dynamicOptions)
                    ? _.map(field.dynamicOptions, (item, key) => (
                      <MenuItem style={{ whiteSpace: 'normal' }} key={key} value={item.id} id={item.name} data-description={item.description}>
                        {item.name}
                      </MenuItem>
                    ))
                    : !_.isNil(field.dict_identifier)
                      ? _.map(field.options, (item, key) => (
                        <MenuItem key={key} value={['numery_1_20', 'numery_0_10'].includes(field.dict_identifier) ? item.name : item.id} id={item.name}>
                          {item.name}
                        </MenuItem>
                      ))
                      : _.map(field.options, (name, key) => (
                        <MenuItem key={key} value={name} id={name}>
                          {name}
                        </MenuItem>
                      ))
                  : null}
              </Select>
              <Typography color="green">{description}</Typography>
              { numRows !== '' && _.map([...Array(numRows)], (row, numRow) => <Stack gap={3} key={numRow} direction={isDesktop ? 'row' : 'column'} sx={getRowStyle()}>
                {_.map(field.multichar_fields, (mField, key) => <Row
                  numRow={numRow}
                  key={key}
                  index={key}
                  formik={formik}
                  field={mField}
                  originFieldName={field.name}
                  originalField={field}
                  wr312ChildrenCountIsSet={wr312ChildrenCountIsSet}
                  wr03ChildrenCountIsSet={wr03ChildrenCountIsSet}
                  wr6PlusChildrenCountIsSet={wr6PlusChildrenCountIsSet}
                  wr05ChildrenCountIsSet={wr05ChildrenCountIsSet}
                />
                )}
              </Stack>
              )}
              {
                !_.isEmpty(field.infos)
                  ? _.map(field.infos, (info, key) => {
                    if (info.no_choices) {
                      return <Typography key={key} color={info.color}>
                        {!_.isNil(formik.values[field.name])
                          ? !_.isNil(field.dynamicOptions)
                            ? field.dynamicOptions.length > 0
                              ? null
                              : info.label
                            : info.label
                          : info.label}
                      </Typography>;
                    }
                  })
                  : null
              }

            </>
          )
        }
        <FormHelperText>{formik.touched[field.name] && formik.errors[field.name]}</FormHelperText>
        {/* {
          !_.isEmpty(field.infos)
            ? _.map(field.infos, (info, key) => {
              if (info.no_choices === false) {
                return <InfoField info={info} key={key} getFieldCallback={getFieldCallback} formikValues={formik.values} infoDynamicText={field.infos.length == key + 1 ? data?.info_field : undefined}/>;
              }
            })
            : null
        } */}
      </FormControl>
    </Stack>
  );
};
